import { FC, useState } from 'react'
import Modal, { ModalProps } from '~shared/Modal'
import SignInForm, { SignInFormProps } from 'components/auth/sign-in'
import PhoneNumberVerificationFrom from 'components/forms/phone-number-verification'
import { Heading, Typography } from '~ui'
import { GRANTED_REWARDS } from 'routes/paths'
import { useRouter } from 'next/router'

type ReferralSignInModalProps = { onCompleted: () => void } & Pick<
  ModalProps,
  'isOpen' | 'onClose'
> &
  Pick<SignInFormProps, 'initialValues'>

type ReferralSignInModalBodyProps = Pick<ReferralSignInModalProps, 'onCompleted' | 'initialValues'>

const ReferralSignInModalBody: FC<ReferralSignInModalBodyProps> = ({
  onCompleted,
  initialValues,
}) => {
  const [isPhoneNumberVerifyFormVisible, setIsPhoneNumberVerifyFormVisible] = useState(false)

  const { push } = useRouter()

  if (isPhoneNumberVerifyFormVisible) {
    return (
      <PhoneNumberVerificationFrom
        onCompleted={() => onCompleted()}
        sendVerificationCodeHeader={
          <Typography.Paragraph center>
            Let&apos;s keep it real (and safe). Verify your mobile number to redeem your credit and
            create your account.
          </Typography.Paragraph>
        }
        checkVerificationCodeHeader={
          <Typography.Paragraph center>
            Last step! Enter the code we texted you and you&apos;re in!
          </Typography.Paragraph>
        }
      />
    )
  }

  return (
    <SignInForm
      initialValues={initialValues}
      header={
        <>
          <Heading colorGlow="g-green" Tag="span" size="h4" uppercase>
            You&apos;ve already signed up!
          </Heading>
          <Typography.Text color="light-gray">
            Looks like you already have an account with us. Just sign in here to get started earning
            Granted Rewards!
          </Typography.Text>
        </>
      }
      onCompleted={({ isPhoneNumberVerified }) => {
        if (isPhoneNumberVerified) {
          push(GRANTED_REWARDS)
          return
        }

        setIsPhoneNumberVerifyFormVisible(true)
      }}
    />
  )
}

const ReferralSignInModal: FC<ReferralSignInModalProps> = ({
  isOpen,
  onClose,
  onCompleted,
  initialValues,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ReferralSignInModalBody onCompleted={onCompleted} initialValues={initialValues} />
  </Modal>
)

export default ReferralSignInModal
